import { lazy, Suspense, useState, type ReactElement } from 'react';
import { useNavigationMenu } from './menu-context';

const MobileMenuDropdown = lazy(() => import('./mobile-menu-dropdown'));

/**
 * Defers fetching/mounting the mobile Sheet chunk until the first open.
 * Matches the CartSheet / README-PERFORMANCE overlay pattern.
 */
export function DeferredMobileMenuDropdown(): ReactElement | null {
    const { isOpen } = useNavigationMenu();
    const [loaded, setLoaded] = useState(false);

    // Flip once when the menu opens — same render-time state sync pattern as CartBadge.
    if (isOpen && !loaded) {
        setLoaded(true);
    }

    if (!loaded) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <MobileMenuDropdown />
        </Suspense>
    );
}
